import { createGlobalStyle } from 'styled-components';

import { theme } from './theme';
import { size } from './helpers';
import themeStyles from '../../styles/theme.css';

export const GlobalStyle = createGlobalStyle`
  ${themeStyles}
  
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    -webkit-text-size-adjust: 100%;
    background-color: ${theme.colors.bg.outer};

    &.wf-not-loaded:not(.no-js) {
      font-size: 15px;

      body {
        font-family: Arial, sans-serif;
        letter-spacing: -0.01em;
        line-height: 1.6;
      }
    }
  }

  body {
    position: relative;
    margin: 0 auto;
    font-family: ${theme.font.family.main};
    line-height: ${theme.font.lineHeight};
    letter-spacing: ${theme.font.letterSpacing};
    max-width: ${theme.distances.bodyMaxWidth};
    background-color: ${theme.colors.bg.main};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  input,
  textarea {
    -webkit-appearance: none;
  }

  a {
    background-color: transparent;
    color: currentColor;
    text-decoration: none;
  }

  a img {
    border: 0;
  }

  b,
  strong {
    font-weight: ${theme.font.weight.medium};
  }

  p {
    margin: ${size(2)} 0;
  }

  svg:not(:root) {
    overflow: hidden;
  }

  button {
    position: relative;
    display: inline-block;
    padding: 0;
    margin: 0;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    font-size: inherit;
    line-height: 1.2;
    color: currentColor;
    font-family: ${theme.font.family.main};
    letter-spacing: inherit;
    cursor: pointer;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 500;
    font-family: ${theme.font.family.brand};
  }

  h1 {
    font-size: 32px;
    line-height: 1.25;

    ${theme.screens.Md} {
      font-size: 40px;
      line-height: 1.2;
    }
  }

  h2 {
    font-size: 24px;
    line-height: 1.333;

    ${theme.screens.Md} {
      font-size: 32px;
      line-height: 1.25;
    }
  }

  h3 {
    font-size: 20px;
    line-height: 1.2;

    ${theme.screens.Md} {
      font-size: 24px;
      line-height: 1.333;
    }
  }

  h4 {
    font-size: 16px;
    line-height: 1.5;

    ${theme.screens.Md} {
      font-size: 20px;
      line-height: 1.4;
    }
  }

  hr {
    height: 1px;
    width: 100%;
    border: 0;
    margin: ${size(2)} 0;
    background-color: ${theme.colors.border.main};
  }




  /* Moved in from CSS-file */
  .hidden {
    display: none !important;
  }

  .text-right {
    text-align: right;
  }
  .text-center {
    text-align: center;
  }

  .white-space-nowrap {
    white-space: nowrap;
  }

  .l-flex {
    display: flex;
  }
  .flex-a-c {
    align-items: center;
  }
  .flex-j-c {
    justify-content: center;
  }

  .flex-grow {
    flex-grow: 1;
  }
  
  .overflow-scroll {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
  }

  .bump-left {
    margin-left: ${size(0.5)};
  }
  .bump-right {
    margin-right: ${size(0.5)};
  }
  .bump-down {
    margin-bottom: ${size(0.5)};
  }

  @keyframes loadingRotate {
    100% {
      transform: rotate(360deg);
    }
  }

  .loading {
    position: relative;
  }

  .loading:before {
    content: "";
    position: absolute;
    z-index: 70;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.75);
  }

  .loading:after {
    content: " ";
    position: absolute;
    z-index: 75;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    animation: loadingRotate 1.2s linear infinite;
    margin: 1px;
    margin: auto;
    border: 5px solid #b6b6b6;
    border-color: #b6b6b6 #b6b6b6 #b6b6b6 transparent;
    border-radius: 50%;
    width: 48px;
    height: 48px;
  }
  
  .m-b {
    margin-bottom: 16px;
  }

  .m-r-mini {
    margin-right: 4px;
  }

  .m-half {
    margin: 8px;
  }

  .m-t-half {
    margin-top: 8px;
  }

  .m-l-half {
    margin-left: 8px;
  }

  .m-r-half {
    margin-right: 8px;
  }

  .m-b-double {
    margin-bottom: 32px;
  }

  .no-wrap {
    white-space: nowrap;
  }

  ${theme.screens.LtSm} {
    .hidden-lt-sm {
      display: none !important;
    }
  }

  ${theme.screens.LtMd} {
    .hidden-lt-md {
      display: none !important;
    }
  }

  ${theme.screens.Md} {
    .hidden-md {
      display: none !important;
    }
  }
`;
